// import React, { useState, useRef } from "react";
// import {
//   useReactTable,
//   getCoreRowModel,
//   getPaginationRowModel,
//   getSortedRowModel,
//   getFilteredRowModel,
// } from "@tanstack/react-table";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";

// export default function CommonReactTable({
//   columns,
//   data,
//   showPagination = true,
//   showFooter = false,
//   align = "right",
//   decimal,
//   showPrint = false,
//   showExcel = false,
//   filename = "Table_Report",
// }) {
//   const [globalFilter, setGlobalFilter] = useState("");

//   // PAGE SIZE
//   const pageSize = showPagination ? 10 : data.length;

//   const table = useReactTable({
//     data,
//     columns,
//     state: {
//       globalFilter,
//       pagination: { pageIndex: 0, pageSize },
//     },
//     onGlobalFilterChange: setGlobalFilter,
//     getCoreRowModel: getCoreRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//   });

//   const rows = table.getRowModel().rows;
//   const pageIndex = table.getState().pagination.pageIndex;

//   // ================= PRINT =================
//   const tableRef = useRef(null);

//   // const handlePrint = useReactToPrint({
//   //   content: () => tableRef.current, // ✅ must be a function
//   //   documentTitle: "My_Report",
//   // });

//   // ================= EXCEL =================
//   const handleExcel = () => {
//     if (!data || data.length === 0) return;

//     const worksheet = XLSX.utils.json_to_sheet(data);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//     const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${filename}.xlsx`);
//   };

//   // ================= FOOTER TOTALS =================
//   const rowsCount = (col) => {
//     let countSum = 0;
//     const rdata = data.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);

//     if (col?.FooterParamAction) {
//       let params = col.Footerparams?.split("-");
//       const sum1 = rdata.reduce((sum, row) => sum + row[params[0]], 0);
//       const sum2 = rdata.reduce((sum, row) => sum + row[params[1]], 0);
//       const sum3 = rdata.reduce((sum, row) => sum + row[params[2]], 0);

//       if (col.FooterParamAction === "-") {
//         countSum = sum1 - sum2 - sum3;
//       } else if (col.FooterParamAction === "/") {
//         countSum = parseFloat(((sum1 / sum2) * 100).toFixed(1));
//       } else {
//         countSum = sum1 + sum2;
//       }
//     } else {
//       countSum = rdata.reduce((sum, row) => sum + row[col.Footer], 0);
//     }

//     if (!isNaN(countSum)) {
//       return decimal === "two" ? countSum.toFixed(2) : countSum;
//     }
//     return "";
//   };

//   return (
//     <div>
//       {/* ================= SEARCH + ACTIONS ================= */}
//       <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
//         <input
//           value={globalFilter ?? ""}
//           onChange={(e) => setGlobalFilter(e.target.value)}
//           placeholder="Search..."
//           style={{ padding: "5px 10px", width: 200 }}
//         />

//         <div style={{ display: "flex", gap: 10 }}>
//           {showExcel && (
//             <button className="btn btn-success btn-sm" onClick={handleExcel}>
//               <PiMicrosoftExcelLogoFill size={25} />   Excel
//             </button>
//           )}
//           {/* {showPrint && (
//             <button className="btn btn-primary btn-sm" onClick={() => {
//               if (!tableRef.current) {
//                 alert("There is nothing to print");
//                 return;
//               }
//               handlePrint();
//             }}>
//               Print
//             </button>
//           )} */}
//         </div>
//       </div>

//       {/* ================= TABLE ================= */}
//       <div ref={tableRef}>
//         <table className="table table-striped table-bordered" style={{ width: "100%", borderCollapse: "collapse" }}>
//           <thead>
//             {table.getHeaderGroups().map((hg) => (
//               <tr key={hg.id}>
//                 {hg.headers.map((header) => (
//                   <th
//                     key={header.id}
//                     onClick={header.column.getToggleSortingHandler()}
//                     style={{ cursor: "pointer" }}
//                   >
//                     {header.isPlaceholder ? null : header.column.columnDef.header}
//                     {header.column.getIsSorted() === "asc" ? " 🔼" : ""}
//                     {header.column.getIsSorted() === "desc" ? " 🔽" : ""}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>

//           <tbody>
//             {rows.length === 0 ? (
//               <tr>
//                 <td colSpan={columns.length} style={{ textAlign: "center" }}>
//                   No Records Found
//                 </td>
//               </tr>
//             ) : (
//               rows.map((row) => (
//                 <tr key={row.id}>
//                   {row.getVisibleCells().map((cell) => (
//                     <td key={cell.id}>
//                       {cell.column.columnDef.cell
//                         ? cell.column.columnDef.cell(cell.getContext())
//                         : cell.getValue()}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             )}
//           </tbody>

//           {showFooter && rows.length !== 0 && (
//             <tfoot>
//               <tr style={{ color: "red" }}>
//                 {columns.map((col, index) => (
//                   <td
//                     key={index}
//                     style={{
//                       fontWeight: "bold",
//                       textAlign: align === "center" ? "center" : "right",
//                       borderTop: "1px solid #ccc",
//                     }}
//                   >
//                     {!col.Footer ? "" : col.Footer === "Total" ? col.Footer : rowsCount(col)}
//                   </td>
//                 ))}
//               </tr>
//             </tfoot>
//           )}
//         </table>
//       </div>

//       {/* ================= PAGINATION ================= */}
//       {showPagination && (
//         <div style={{ marginTop: 15 }}>
//           <button onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
//             Previous
//           </button>
//           <span style={{ margin: "0 10px" }}>
//             Page {table.getState().pagination.pageIndex + 1}
//           </span>
//           <button onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

//

import React, { useState, useRef } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaFileExcel, FaPrint } from "react-icons/fa";
export default function CommonReactTable({
  columns,
  data,
  headerName,
  showPagination = true,
  showFooter = "false",
  align = "right",
  decimal,
  showPrint = false,
  showExcel = false,
  excelFileName,
}) {
  const [globalFilter, setGlobalFilter] = useState("");

  // PAGE SIZE
  const pageSize = showPagination ? 10 : data.length;

  const table = useReactTable({
    data,
    columns,
    state: {
      globalFilter,
      pagination: { pageIndex: 0, pageSize },
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  const rows = table.getRowModel().rows;
  const pageIndex = table.getState().pagination.pageIndex;

  const tableRef = useRef(null);

  // ===== PRINT =====
  const handlePrint = useReactToPrint({
    contentRef: tableRef, // ✅ must be contentRef for v3+
    documentTitle: excelFileName,
    pageStyle: `
    @media print {
      /* Force the headerName row background color */
      thead tr:first-child th {
        background-color: #472b2b !important;
        color: #000 !important;
      }
    }
  `,
  });


  // ===== EXCEL EXPORT =====
  const handleExcelExport = () => {
    const rows = table.getFilteredRowModel().rows; // filtered rows
    const columns = table.getAllLeafColumns();

    const excelData = rows.map((row, index) => {
      const rowData = {};

      // ✅ ADD SERIAL NUMBER
      rowData["Sl.No"] = index + 1;

      columns.forEach((col) => {
        const header =
          typeof col.columnDef.header === "string"
            ? col.columnDef.header
            : col.id;

        // avoid duplicate sl.no if exists in columns
        if (header === "Sl.No") return;

        rowData[header] = row.original[col.id];
      });

      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `${excelFileName}.xlsx`);
  };


  // ===== FOOTER LOGIC =====
  function rowsCount(col) {
    let countSum = 0;
    const rdata = data?.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);

    if (col?.FooterParamAction) {
      let params = col.Footerparams?.split("-");
      let paramsum1 = rdata?.reduce((sum, row) => sum + row[params[0]], 0);
      let paramsum2 = rdata?.reduce((sum, row) => sum + row[params[1]], 0);
      let paramsum3 = rdata?.reduce((sum, row) => sum + row[params[2]], 0);

      if (col.FooterParamAction === "-") {
        countSum =
          parseInt(paramsum1) - parseInt(paramsum2) - parseInt(paramsum3);
      } else if (col.FooterParamAction === "/") {
        countSum = parseFloat(
          ((parseInt(paramsum1) / parseInt(paramsum2)) * 100).toFixed(1),
        );
      } else {
        countSum = parseInt(paramsum1) + parseInt(paramsum2);
      }
    } else {
      countSum = rdata?.reduce((sum, row) => sum + row[col.Footer], 0);
    }

    if (!isNaN(countSum)) {
      if (decimal === "two") return countSum.toFixed(2);
      return countSum;
    }
    return "";
  }

  return (
    <>
      {/* ===== SEARCH + ACTIONS ===== */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "end",
          marginBottom: 10,
        }}
      >
        <input
          value={globalFilter ?? ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          style={{ padding: "5px 10px", width: "300px" }}
        />

        {showExcel && (
          <button
            type="button"
            className="btn btn-sm btn-success"
            onClick={handleExcelExport}
          >
            <FaFileExcel size={18} /> Excel
          </button>
        )}

        {showPrint && (
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={handlePrint}
          >
            <FaPrint size={18} /> Print
          </button>
        )}
      </div>

      {/* ===== TABLE ===== */}
      <table
        ref={tableRef}
        id="common-react-table"
        className="table table-striped table-hover table-bordered"
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <thead>
          {/* CUSTOM HEADER NAME */}
          {headerName && (
            <tr>
              <th
                colSpan={columns.length}
                style={{
                  textAlign: "center",
                  fontSize: "1rem",
                  backgroundColor: "#3b1600",
                }}
              >
                {headerName}
              </th>
            </tr>
          )}

          {/* REACT TABLE COLUMN HEADERS */}
          {table.getHeaderGroups().map((hg) => (
            <tr key={hg.id}>
              {hg.headers.map((header) => (
                <th
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                  style={{ cursor: "pointer" }}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                  {header.column.getIsSorted() === "asc" ? " 🔼" : ""}
                  {header.column.getIsSorted() === "desc" ? " 🔽" : ""}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No Records Found
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {cell.column.columnDef.cell
                      ? cell.column.columnDef.cell(cell.getContext())
                      : cell.getValue()}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>

        {showFooter === "true" && rows.length !== 0 && (
          <tfoot>
            <tr style={{ color: "red" }}>
              {columns.map((col, index) => (
                <td
                  key={index}
                  style={{
                    fontWeight: "bold",
                    textAlign: align === "center" ? "center" : "right",
                    borderTop: "1px solid #ccc",
                  }}
                >
                  {!col.Footer
                    ? ""
                    : col.Footer === "Total"
                      ? col.Footer
                      : rowsCount(col)}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>

      {/* ===== PAGINATION ===== */}
      {showPagination && (
        <div style={{ marginTop: 15 }}>
          <button
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            Previous
          </button>
          <span style={{ margin: "0 10px" }}>
            Page {table.getState().pagination.pageIndex + 1}
          </span>
          <button
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
}
